import { create } from 'zustand';
import { SETTINGS_VIEW, SettingsStore } from './SettingsStore.consts';

export const useSettingsStore = create<SettingsStore>((set) => ({
  view: SETTINGS_VIEW.MAIN,
  setView: (view: SETTINGS_VIEW) => {
    set(() => ({ view }));
  },
}));
